import {
  REQUEST_PASSWORD_REQUEST,
  REQUEST_PASSWORD_SUCCESS,
  REQUEST_PASSWORD_FAILURE,
  RESET_FORGET_PASSWORD,
} from '../../constants/ActionTypes'

const initialState = {
  requesting: false,
  requested: false,
  error: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PASSWORD_REQUEST:
      return {
        error: {},
        requesting: true,
        requested: false,
      }
    case REQUEST_PASSWORD_SUCCESS:
      return {
        requesting: false,
        requested: true,
        error: {}
      };
    case REQUEST_PASSWORD_FAILURE: {
      let error = {};
      error.email = action.payload.error.message;

      return {
        requesting: false,
        requested: false,
        error: error,
      }
    }
    case RESET_FORGET_PASSWORD:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/forgetPassword.js